/**
 * 用量表务预警（meterUseWarnManagement）模块英文映射（中文原文 → 英文 扁平映射）
 * 覆盖范围：src/views/meterUseWarnManagement/ 下列表页及 modules/ 弹窗
 */
export default {
  // ---- 预警配置列表页 meterUseWarnConfigList.vue ----
  '流量告警配置页面': 'Flow Alarm Config Page',
  '规则名称': 'Rule Name',
  '请输名称进行查询': 'Enter a name to search',
  '请输入规则名称': 'Please enter rule name',
  '价格名称': 'Price Name',
  '请选择价格名称': 'Please select price name',
  '表口径': 'Meter Caliber',
  '请选择表口径': 'Please select meter caliber',
  '价格信息': 'Price Info',
  '是否启用': 'Enabled',
  '未启用': 'Not Enabled',
  '启用': 'Enabled',
  '未知': 'Unknown',
  '元': 'CNY',
  '无图片': 'No Image',
  '无文件': 'No File',
  '下载': 'Download',
  '用户明细': 'Customer Details',

  // ---- 预警配置弹窗 meterUseWarnConfigModal.vue ----
  '规则类型': 'Rule Type',
  '请选择规则类型': 'Please select rule type',
  '比较值(日用量:m³)': 'Compare Value (Daily Usage: m³)',
  '请输入比较值': 'Please enter compare value',
  '备注': 'Remark',
  '请输入备注': 'Please enter remark',
  '该规则名称已存在!': 'This rule name already exists!',
  '该价格和口径告警配置启用数不能大于5': 'The number of enabled alarm configs for this price and caliber cannot exceed 5',

  // ---- 预警记录列表页 meterUseWarnRecordList.vue ----
  '当前选择：': 'Currently selected:',
  '取消选择': 'Deselect',
  '请输入区域名称': 'Please enter area name',
  '折叠': 'Collapse',
  '收起': 'Collapse',
  '展开': 'Expand',
  '区域名称': 'Area Name',
  '用户编号': 'Customer No.',
  '请输入用户编号': 'Please enter customer No.',
  '用户姓名': 'Customer Name',
  '请输入用户姓名': 'Please enter customer name',
  '表编号': 'Meter No.',
  '请输入表编号': 'Please enter meter No.',
  '用户地址': 'Customer Address',
  '处理状态': 'Handling Status',
  '请选择处理状态': 'Please select handling status',
  '未处理': 'Unprocessed',
  '处理中': 'Processing',
  '已处理': 'Processed',
  '处理': 'Handle',
  '处理进度': 'Handling Progress',
  '处理描述': 'Handling Description',
  '请输入处理描述': 'Please enter handling description',
  '批量处理': 'Batch Handle',
  '只能批量选择未处理的记录！': 'Only unprocessed records can be selected for batch handling!',
  '告警规则': 'Alarm Rule',
  '告警描述': 'Alarm Description',
  '日用量': 'Daily Usage',
  '日用量(m³)': 'Daily Usage (m³)',
  '报表日期': 'Report Date',
  '请设置url.list属性!': 'Please set the url.list property!',

  // ---- 预警记录详情/处理弹窗 meterUseWarnRecordModal.vue / meterUseWarnRecordDealModal.vue ----
  '数据详情': 'Data Details',
  '历史流量记录': 'Historical Flow Records',
  '表安装地址': 'Meter Installation Address',
  '手机号码': 'Mobile Phone',
  '合计单价(元)': 'Total Unit Price (CNY)',
  '查询起始时间': 'Start time',
  '查询结束时间': 'End time',
}
